export default __webpack_public_path__ + "static/media/paypal-logo.737c3149.png";